import React, { useEffect } from 'react';
import {
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { IoAlertCircleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';

type CreateUserModalProps = {
  show: boolean,
  title: string,
  success?: boolean,
  description?: string,
  onClose: () => void,
};

function NotificationModal( {
  show, onClose, title, description, success = true,
}: CreateUserModalProps ) {
  const { t } = useTranslation();

  useEffect( () => {
  }, [show] );

  return (
    <Modal
      show={show}
      className="modal-carousel"
      centered
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h4 className="text-center mb-4">{title}</h4>
            <div className="text-center">
              {success ? ( <IoCheckmarkCircleOutline size={34} className="text--green2" /> )
                : ( <IoAlertCircleOutline size={34} className="text-danger" /> )}
              <p className={classNames( 'text--sm mt-3', { 'text--green2': success, 'text-danger': !success } )}>{description}</p>

              <Row>
                <Col className="m-auto mt-3">
                  <Button variant="primary" className="btn--full-width" onClick={onClose}>
                    {t( 'accept' )}
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default NotificationModal;
